// extracted by mini-css-extract-plugin
export var filterIncDec = "_4l-0";
export var leftBorder = "_4l-1";
export var rightBorder = "_4l-2";
export var stringInput = "_4l-3";